/*!

*/
import React, {useEffect, useState} from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, useLocation, useHistory} from "react-router-dom";
import axios from 'axios';
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import API from "../carrental/src/contained/API"
import routes from "routestenant.js";
import jwtDecode from "jwt-decode";
import { useDispatch} from 'react-redux'
import { areaFetch, featureFetch, profileFetch} from "../actions/actions"
import { connect } from 'react-redux'

import swal from 'sweetalert'
import dlogo from "./Logo.jpeg"
import Spin from '../assets/img/Spinner2.gif'


var ps;

function Tenant(props) {
  let history = useHistory();
  let dispatch = useDispatch();
  const [authenticated, setAuthenticated] = useState(false)
  const [showProcessing , setShowProcessing] = useState(false)
  const location = useLocation();
  const [backgroundColor, setBackgroundColor] = React.useState("black");
  const [activeColor, setActiveColor] = React.useState("info");
  const [sidebarMini, setSidebarMini] = React.useState(true);
  const mainPanel = React.useRef();
  const [alert, setAlert] = React.useState(null);
  const [user, setUser] = React.useState({fn : "", cn : "", tuid : ""})

  function authentic ()  {
   
    API.get(`/lgn/testusert`, {
      headers: {
        'arixauth': localStorage.getItem('arixauth')
      }
    }).then(t => {
     
      setAuthenticated(true)
      setUser(jwtDecode(localStorage.getItem('arixauth')))
      let data = jwtDecode(localStorage.getItem('arixauth'))
      dispatch(featureFetch())
      dispatch(areaFetch())
      dispatch(profileFetch(data.tuid))
    }).catch(t => {
    console.log(t)
  //  localStorage.setItem("arixauth", "")
     setAuthenticated(false)
    history.push('/auth/login')
      console.log("user is not authenticated")
  })
  }
    {/**  , backgroundImage : `url(${imgg})`,backgroundRepeat: 'no-repeat', backgroundSize: 'cover' */}
  
  useEffect(() => {
    authentic()
   // dispatch(areaFetch())
  // console.log(user.tuid)

   
   
    
   }, [])

   const SpinnerNew = <div className="spoverlay"><center><img style={{marginTop : 200}} src={Spin} alt="a" width={"200px"}/><h4>Please wait...</h4></center></div>

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanel.current);
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.documentElement.className += " perfect-scrollbar-off";
        document.documentElement.classList.remove("perfect-scrollbar-on");
      }
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
  }, [location]);
  

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/tenant") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={() => <prop.component swal={swal} Spin={SpinnerNew}
             API={API} user={user} alert={alert} history={history}/>}
            key={key}
            
          />
        );
      } else {
        return null;
      }
    });
  };
 
  const handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      setSidebarMini(false);
    } else {
      setSidebarMini(true);
    }
    document.body.classList.toggle("sidebar-mini");
  };



  return (
    <div className="wrapper">
  
      <Sidebar
        {...props}
        routes={routes}
        bgColor={backgroundColor}
        activeColor={activeColor}
        user = {user}
        API = {API}
      />
      <div className="main-panel" ref={mainPanel}>
        <AdminNavbar {...props} handleMiniClick={handleMiniClick} user={user} />
       
        
          {showProcessing && Spin} 
          <>
                  <Switch>{getRoutes(routes)}</Switch>
                  {
                    // we don't want the Footer to be rendered on full screen maps page
                    props.location.pathname.indexOf("full-screen-map") !== -1 ? null : (
                      <Footer fluid />
                    )
                  }
                     
           </> 
        
       
     
       
       
      </div>
     
    </div>
    
  );
}

export default connect(null, {areaFetch, profileFetch} )(Tenant);
